(() => {
  const syncNavButtons = (carousel, navPrev, navNext) => {
    if (!carousel) return;

    const hasPrev = Boolean(carousel.hasPrev);
    const hasNext = Boolean(carousel.hasNext);

    if (navPrev) {
      navPrev.disabled = !hasPrev;
      navPrev.setAttribute('aria-disabled', hasPrev ? 'false' : 'true');
    }

    if (navNext) {
      navNext.disabled = !hasNext;
      navNext.setAttribute('aria-disabled', hasNext ? 'false' : 'true');
    }
  };

  const scheduleNavSync = (carousel, navPrev, navNext) => {
    const run = () => syncNavButtons(carousel, navPrev, navNext);
    run();
    window.requestAnimationFrame(run);
    window.setTimeout(run, 0);
    window.setTimeout(run, 120);
    window.setTimeout(run, 320);
  };

  const initCarouselWrap = (wrap) => {
    if (!wrap || wrap.dataset.hpSearchCarouselInit === 'true') return;
    wrap.dataset.hpSearchCarouselInit = 'true';

    const root = wrap.closest('.hp-search-panel-main, .hp-predictive-search') || wrap;
    const carouselId = wrap.dataset.carouselId || '';
    const navPrev = wrap.querySelector('[data-hp-search-panel-nav="prev"]');
    const navNext = wrap.querySelector('[data-hp-search-panel-nav="next"]');

    const getCarousel = () => {
      if (carouselId) {
        return (
          wrap.querySelector(`grid-carousel#${CSS.escape(carouselId)}`) ||
          root.querySelector(`grid-carousel#${CSS.escape(carouselId)}`)
        );
      }
      return wrap.querySelector('grid-carousel');
    };

    let activeCarousel = null;
    const onCarouselUpdate = () => {
      scheduleNavSync(getCarousel(), navPrev, navNext);
    };

    const bindCarousel = async () => {
      const carousel = getCarousel();
      if (!carousel) return;

      if (carousel.updateComplete) {
        await carousel.updateComplete;
      }

      if (activeCarousel !== carousel) {
        activeCarousel?.removeEventListener('scroll-carousel:update', onCarouselUpdate);
        carousel.addEventListener('scroll-carousel:update', onCarouselUpdate);
        activeCarousel = carousel;
      }

      await window.hpEnableCarouselDragScroll?.(carousel, onCarouselUpdate);

      const track = carousel.shadowRoot?.querySelector('#track');
      if (track) {
        track.style.touchAction = 'pan-x pinch-zoom';
        track.style.webkitOverflowScrolling = 'touch';
      }

      scheduleNavSync(carousel, navPrev, navNext);
    };

    navPrev?.addEventListener('click', async () => {
      const carousel = getCarousel();
      if (!carousel) return;
      if (carousel.updateComplete) await carousel.updateComplete;
      carousel.goPrev?.();
      scheduleNavSync(carousel, navPrev, navNext);
    });

    navNext?.addEventListener('click', async () => {
      const carousel = getCarousel();
      if (!carousel) return;
      if (carousel.updateComplete) await carousel.updateComplete;
      carousel.goNext?.();
      scheduleNavSync(carousel, navPrev, navNext);
    });

    const refresh = () => {
      bindCarousel();
    };

    if (customElements.get('grid-carousel')) {
      refresh();
    } else {
      customElements.whenDefined('grid-carousel').then(refresh);
    }

    document.addEventListener('search:open', refresh);

    const searchPanel = root.closest('search-panel, search-panel-mobile');
    if (searchPanel) {
      const observer = new MutationObserver(() => {
        if (searchPanel.hasAttribute('open')) refresh();
      });
      observer.observe(searchPanel, { attributes: true, attributeFilter: ['open'] });
    }

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(() => {
        scheduleNavSync(getCarousel(), navPrev, navNext);
      });
      resizeObserver.observe(wrap);
    }
  };

  // Boş panel (metafield carousel) + predictive sonuçları (search-panel [data-part=results] içine morph edilir)
  const scan = () => {
    document.querySelectorAll('[data-hp-search-panel-carousel]').forEach(initCarouselWrap);
  };

  const observeSearchResults = () => {
    document
      .querySelectorAll('search-panel [data-part="results"], search-panel-mobile [data-part="results"]')
      .forEach((resultsRoot) => {
        if (resultsRoot.dataset.hpSearchResultsObserved === 'true') return;
        resultsRoot.dataset.hpSearchResultsObserved = 'true';

        new MutationObserver(scan).observe(resultsRoot, { childList: true, subtree: true });
      });
  };

  const boot = () => {
    scan();
    observeSearchResults();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  customElements.whenDefined('search-panel').then(observeSearchResults);
  customElements.whenDefined('search-panel-mobile').then(observeSearchResults);
})();
